// client/src/components/DIVERS/EmailVerifiedPage.js
import React from 'react';
import { FiCheck } from 'react-icons/fi';
import { BrandMark } from '../shared/BrandLogo';

export default function EmailVerifiedPage() {
  return (
    <div className="eb-auth">
      <div className="eb-auth__card" style={{ textAlign: 'center' }}>
        <div className="eb-auth__brand"><BrandMark to={null} /></div>
        <div
          aria-hidden="true"
          style={{
            width: 56, height: 56, margin: '0 auto 16px', borderRadius: '50%',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: 'var(--eb-success-bg)', border: '1px solid #c6f0da',
            color: 'var(--eb-success)', fontSize: 26,
          }}
        >
          <FiCheck />
        </div>
        <h1 className="eb-auth__title">Email confirmé !</h1>
        <p className="eb-auth__subtitle" style={{ margin: '10px 0 4px', lineHeight: 1.65 }}>
          Votre adresse email a bien été vérifiée.<br />
          Vous pouvez fermer cet onglet et retourner sur <strong style={{ color: 'var(--eb-text)', fontWeight: 600 }}>EcoBill</strong>.
        </p>
      </div>
    </div>
  );
}
